import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  constructor() { }
  
  /**
   * Set data in a cookie with 14 days expiration
   * @param name The name of the cookie 
   * @param value The value to store
   * @param additionalDays Optional parameter to override the default 14 days expiration
   */
  setCookie(name: string, value: string, additionalDays: number = 14): void {
    // Create expiration date (14 days from now by default)
    const date = new Date();
    date.setTime(date.getTime() + (additionalDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    
    // Set the cookie with secure flags when possible
    document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Strict; ${location.protocol === 'https:' ? 'Secure;' : ''}`;
  }
  /**
 * Set data in a cookie with optional expiration in days or minutes
 * @param name The name of the cookie 
 * @param value The value to store
 * @param duration Optional duration
 * @param unit 'days' (default) or 'minutes'
 */
setCookieV2(name: string, value: string, duration: number = 14, unit: 'days' | 'minutes' = 'days'): void {
  const date = new Date();

    if (unit === 'minutes') {
      date.setTime(date.getTime() + duration * 60 * 1000); // minutes to milliseconds
    } else {
      date.setTime(date.getTime() + duration * 24 * 60 * 60 * 1000); // days to milliseconds
    }

    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Strict; ${location.protocol === 'https:' ? 'Secure;' : ''}`;
  }
  
  /**
   * Get data from a cookie by name
   * @param name The name of the cookie to retrieve
   * @returns The cookie value or empty string if not found
   */
  getCookie(name: string): string {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(';');
    
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return '';
  }
  
  /**
   * Check if a cookie exists
   * @param name The name of the cookie to check
   * @returns Boolean indicating if the cookie exists
   */
  checkCookie(name: string): boolean {
    return this.getCookie(name) !== '';
  }
  
  /**
   * Delete a cookie
   * @param name The name of the cookie to delete
   */
  deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}
